import * as React from "react";
import {Link} from "react-router-dom";
import {Redirect} from "react-router-dom";
import {cx} from "emotion";

import "./user-assets-layout.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Invoke}         from "@Common/react/invoke";
import {keyed}          from "@Common/react/keyed";
import {Responsive}     from "@Common/ui-components/responsive";
import {buildUrlQuery}  from "@Common/utils/build-url-query";
import {chain}          from "@Common/utils/fs";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {InternalLink} from "@Xpresso/routes/common/components/internal-link";

import {AccountLayout}           from "../../../../../common/account-layout/account-layout";
import {ScheduledCampaignsPanel} from "../../../../../common/scheduled-campaigns-panel/scheduled-campaigns-panel";
import {Header}                  from "../header/header";
import {HeaderMobile}            from "../header/header-mobile";

import {LayoutLoaderContext} from "./user-assets-layout-loader";

export const UserAssetsLayout = (
    {
        activeTab,
        hideTabs=false,
        noPadding=false,
        mobileHideBackLink=false,
        next: rootNext,
    }
) => cs(
    ["step1", ({}, next) => UserAssetsLayout1({
        activeTab,
        hideTabs,
        noPadding,
        mobileHideBackLink,
        next,
    })],
    ({step1}) => step1.render({
        next: () => rootNext({
            reload: step1.reload,
        }),
    }),
);

export const UserAssetsLayout1 = (
    {
        activeTab,
        hideTabs=false,
        noPadding=false,
        mobileHideBackLink=false,
        next: rootNext,
    }
) => cs(
    consumeContext("routerHistory"),
    ["query", ({}, next) => next(parseUrlQuery(window.location.search))],
    ["agentId", ({query}, next) => next(query?.agent)],
    ["branchId", ({query}, next) => next(query?.branch)],
    ({agentId}, next) => (
        !agentId ? (
            <Redirect to="/account/admin/user"/>
        ) : (
            next()
        )
    ),
    ["loader", (_, next) => (
        <LayoutLoaderContext.Consumer>
            {next}
        </LayoutLoaderContext.Consumer>
    )],
    ["headerData", ({loader, agentId}, next) => loader.loadHeaderData({agentId, next})],
    ({headerData, routerHistory}, next) => (
        (headerData.loading || headerData?.agent?.idAgent) ? (
            next()
        ) : (
            Invoke({action: () => {
                headerData.clear();
                routerHistory.replace("/account/admin/user");
            }})
        )
    ),

    consumeContext("accountMenu"),
    ["userManagementMenu", ({accountMenu}, next) => next(
        accountMenu?.adminDropdownMenu?.dropdownItems?.find?.(item => item.configPath === "userManagementMenu")
    )],
    consumeContext("userLevels"),
    consumeContext("company"),
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ["scheduledCampaignsPanel", ({agentId, branchId}, next) => ScheduledCampaignsPanel({
        agentId,
        branchId,
        next,
    })],
    ["sc", ({scheduledCampaignsPanel, agentId, branchId}, next) => {
        if (cachedSc && (cachedSc.agentId !== agentId || cachedSc.branchId !== branchId)) {
            cachedSc = null;
        }
        if (!scheduledCampaignsPanel.loading) {
            cachedSc = {
                agentId, branchId,
                available: scheduledCampaignsPanel.available,
                linkLabel: scheduledCampaignsPanel.linkLabel,
            };
        }
        return next(cachedSc);
    }],

    ["items", ({userManagementMenu, sc}, next) => next(chain(
        userManagementMenu?.subMenu ?? itemsConfig,
        (_) => _.filter((item) => item.name !== "admin-scheduled-campaigns" || sc?.available),
        (_) => _.map((item) => item.name !== "admin-scheduled-campaigns" ? item : {
            ...item,
            linkLabel: sc?.linkLabel ?? item.linkLabel,
        }),
    ))],

    ({headerData, agentId, branchId, scheduledCampaignsPanel, items, responsive}) => rootNext({

        reload: headerData.reload,
        renderScheduledCampaignsPanel: scheduledCampaignsPanel.render,

        render: (
            {
                navBlock,
                next,
            }
        ) => cs(

            ({}, next) => AccountLayout({
                active: "userManagement",
                navBlock,
                next,
            }),
            ({}, next) => <>
                {!mobileHideBackLink && responsive.lt("md") && (
                    <div className="back-section-5fd">
                        {InternalLink({
                            className: "back",
                            to: "/account/admin/user",
                            "xd-qa-type": "link",
                            "xd-qa-name": "Back",
                            navBlock,
                            children: <>
                                <i className="fa fa-chevron-left"/>
                                User Management
                            </>,
                        })}
                    </div>
                )}

                <div className="user-assets-tabs-layout-5fd">
                    {responsive.lt("md") ? (
                        HeaderMobile({
                            data: headerData,
                            activeTabLink: (
                                items.find((item) => activeTab === item.name)?.link + buildUrlQuery({
                                    ...agentId && {
                                        agent: agentId
                                    },
                                    ...branchId && {
                                        branch: branchId
                                    },
                                })
                            ),
                            agentId,
                            branchId,
                            activeTab,
                            navBlock,
                            items,
                        })
                    ) : <>
                        {Header({
                            data: headerData,
                            branchId,
                            backTo: '/account/admin/user',
                            navBlock,
                            activeTabLink: (
                                items.find((item) => activeTab === item.name)?.link + buildUrlQuery({
                                    ...agentId && {
                                        agent: agentId
                                    },
                                    ...branchId && {
                                        branch: branchId
                                    },
                                })
                            ),
                        })}

                        {items.length > 1 && !hideTabs && (
                            <div className="tabs">
                                {items.map((item) => cs(
                                    keyed(item.name),
                                    // ["config", ({}, next) => next(itemsConfig.find((ic) => ic.name === item.name))],
                                    ["to", (_, next) => next(item.link + buildUrlQuery({
                                        ...agentId && {
                                            agent: agentId
                                        },
                                        ...branchId && {
                                            branch: branchId
                                        },
                                    }))],
                                    consumeContext("routerHistory"),
                                    ({to, routerHistory}) => (
                                        <Link
                                            className={cx("item", {active: activeTab === item.name})}
                                            replace={true}
                                            to={to}

                                            onClick={async (e) => {
                                                e.preventDefault();
                                                if (await navBlock?.block() === true) {
                                                    return;
                                                }
                                                routerHistory.push(to);
                                            }}
                                            xd-qa-type="link"
                                            xd-qa-name={item.linkLabel}
                                        >
                                            {item.linkLabel}
                                        </Link>
                                    ),
                                ))}
                            </div>
                        )}
                    </>}
                    <div className={cx("content", {noPadding})}>
                        {next()}
                    </div>
                </div>
            </>,
            ({}) => next(),
        ),
    }),

);

let cachedSc = undefined;

const itemsConfig = [
    {
        linkLabel: "Headshots",
        name: "admin-headshots",
        link: "/account/admin/user/headshots",
    },
    {
        linkLabel: "Logos",
        name: "admin-logos",
        link: "/account/admin/user/logos",
    },
    {
        linkLabel: "Shipping Addresses",
        name: "admin-shipping",
        link: "/account/admin/user/shipping",
    },
    {
        linkLabel: "Address Lists",
        name: "admin-address-lists",
        link: "/account/admin/user/address-lists",
    },
    {
        linkLabel: "Mailing Assets",
        name: "admin-mailing-assets",
        link: "/account/admin/user/mailing-assets",
    },
    {
        linkLabel: "Credit Cards",
        name: "admin-credit-cards",
        link: "/account/admin/user/credit-cards",
    },
    {
        linkLabel: "Scheduled Campaigns",
        name: "admin-scheduled-campaigns",
        link: "/account/admin/user/scheduled-campaigns",
    },
    {
        linkLabel: "Social Media",
        name: "admin-social",
        link: "/account/admin/user/social",
    },
];
